/* LOLLIA STORE · native Shopify forms remain usable without JavaScript. */
(() => {
  'use strict';
  const root = document.body.dataset.rootUrl || window.Shopify?.routes?.root || '/';
  const endpoint = (path) => root.replace(/\/?$/, '/') + path;

  const showMedia = (scope, id) => {
    if (!id || !scope.querySelector(`[data-media-id="${id}"]`)) return;
    scope.querySelectorAll('[data-media-id]').forEach((media) => {
      const visible = media.dataset.mediaId === String(id);
      media.hidden = !visible;
      if (!visible) media.querySelectorAll('video').forEach((video) => video.pause());
    });
    scope.querySelectorAll('[data-media-target]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id)));
    });
  };

  function setupProduct(scope) {
    if (scope.dataset.initialized === 'true') return;
    scope.dataset.initialized = 'true';
    const form = scope.querySelector('[data-product-form]');
    const selector = form?.querySelector('[data-variant-select]');
    const variantScript = scope.querySelector('[data-product-variants]');
    if (!form || !selector || !variantScript) return;
    let variants;
    try { variants = JSON.parse(variantScript.textContent); } catch { return; }
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const status = form.querySelector('[data-product-status]');
    const confirmation = form.querySelector('[data-cart-confirmation]');
    const quantity = form.querySelector('input[name="quantity"]');
    const priceBox = scope.querySelector('.product-details .price');
    let submitting = false;
    const currentVariant = () => variants.find((variant) => String(variant.id) === selector.value);
    function updateVariant() {
      const variant = currentVariant();
      if (!variant) { button.disabled = true; label.textContent = 'Indisponible'; return; }
      const price = priceBox?.querySelector('[data-price]');
      if (price) price.textContent = variant.price;
      let compare = priceBox?.querySelector('[data-compare-price]');
      if (variant.compare && priceBox) {
        if (!compare) { compare = document.createElement('s'); compare.dataset.comparePrice = ''; priceBox.appendChild(compare); }
        compare.textContent = variant.compare;
      } else compare?.remove();
      priceBox?.classList.toggle('price--sale', !!variant.compare);
      button.disabled = !variant.available || submitting;
      label.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      if (quantity) {
        quantity.min = String(variant.min || 1);
        quantity.step = String(variant.step || 1);
        if (variant.max != null) quantity.max = String(variant.max); else quantity.removeAttribute('max');
        const min = Number(quantity.min), step = Number(quantity.step);
        let value = Math.max(min, Number(quantity.value) || min);
        value = min + Math.ceil((value - min) / step) * step;
        if (variant.max != null) value = Math.min(value, Number(variant.max));
        quantity.value = String(value);
      }
      showMedia(scope, variant.mediaId);
      status.textContent = '';
      status.removeAttribute('data-error');
      confirmation.hidden = true;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url);
    }
    selector.addEventListener('change', updateVariant);
    form.addEventListener('submit', async (event) => {
      if (event.submitter && event.submitter.name !== 'add') return;
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (submitting || !form.reportValidity()) return;
      const variant = currentVariant();
      if (!variant?.available) return;
      submitting = true;
      button.disabled = true;
      label.textContent = 'Ajout en cours…';
      status.textContent = '';
      status.removeAttribute('data-error');
      confirmation.hidden = true;
      let added = false;
      try {
        const data = new FormData(form);
        data.delete('return_to');
        const response = await fetch(endpoint('cart/add.js'), {
          method: 'POST', body: data,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Cet article ne peut pas être ajouté pour le moment.');
        added = true;
        status.textContent = 'Votre sélection a été ajoutée au panier.';
        confirmation.hidden = false;
        try {
          const cartResponse = await fetch(endpoint('cart.js'), {headers: {Accept: 'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach((node) => {
              node.textContent = String(cart.item_count);
              node.closest('.cart-link')?.setAttribute('aria-label', `Panier, ${cart.item_count} article(s)`);
            });
          }
        } catch { /* The item was added; the native cart page will show its count. */ }
      } catch (error) {
        status.textContent = error instanceof Error ? error.message : 'L’ajout n’a pas abouti. Vérifiez votre connexion puis consultez le panier avant de réessayer.';
        status.dataset.error = 'true';
      } finally {
        submitting = false;
        button.disabled = !currentVariant()?.available;
        label.textContent = currentVariant()?.available ? 'Ajouter au panier' : 'Épuisé';
        if (added) confirmation.focus({preventScroll: true});
      }
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const quantityButton = target.closest('[data-quantity-action]');
    if (quantityButton) {
      const input = quantityButton.closest('[data-quantity]')?.querySelector('input');
      if (input) {
        const min = Number(input.min || 0), max = input.max ? Number(input.max) : Infinity;
        const step = Number(input.step || 1), current = Number(input.value) || min;
        const next = current + (quantityButton.dataset.quantityAction === 'plus' ? step : -step);
        input.value = String(Math.max(min, Math.min(max, next)));
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
    const thumb = target.closest('[data-media-target]');
    if (thumb) showMedia(thumb.closest('[data-gallery]'), thumb.dataset.mediaTarget);
    document.querySelectorAll('.nav-dropdown[open], .mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open], .mobile-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(setupProduct);
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
